import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createCrud, useAxiosClient, useMutation } from '@lumahealthhq/ui-model';
var BASE_URL = 'lumaPayCharges';
var crud = createCrud(BASE_URL);

/* Default queries */
// Get charges from patient appointment to staff view
export var useLumaPayChargeMany = crud.makeFindMany();
export var useLumaPayChargeUpdatePayment = function useLumaPayChargeUpdatePayment() {
  var axiosClient = useAxiosClient();
  var mutationFn = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
      var _yield$axiosClient$pu, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axiosClient.put("v2/".concat(BASE_URL), payload);
          case 2:
            _yield$axiosClient$pu = _context.sent;
            data = _yield$axiosClient$pu.data;
            return _context.abrupt("return", data);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function mutationFn(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return useMutation([BASE_URL], mutationFn);
};